interface Props {
  onClick: () => void;
  disabled?: boolean;
}

/** Toolbar button that opens the public-view preview for the current form. */
export default function PreviewButton({ onClick, disabled = false }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="border border-gray-200 text-gray-700 text-sm font-medium px-5 py-2.5 rounded-lg hover:border-red-300 disabled:opacity-50 transition-colors"
    >
      Xem trước
    </button>
  );
}
